<!--
  A ordem do DOM não é a ordem visual: o botão fechar vem antes do corpo para o
  Tab alcançá-lo primeiro, e o SCSS recoloca cada filho com `grid-row`/
  `grid-column`. Sem raiz interativa própria — o toast é um cartão com dois
  botões, não um botão gigante: fechar e agir são intenções diferentes.

  Nada de `role`/`aria-live` aqui: quem anuncia é o container
  (`role="status" aria-live="polite"`), senão cada toast abriria uma região
  viva nova e o leitor de tela repetiria a fila inteira.
-->
<span class="nt-toast__ic" aria-hidden="true">
  <lkt-icon [name]="item().icon" [size]="16" />
</span>

<span class="nt-toast__title">
  <strong class="nt-toast__subject">{{ item().subject }}</strong> {{ item().message }}
</span>

<button
  type="button"
  class="nt-toast__close"
  aria-label="Fechar notificação"
  [attr.data-cy]="closeDataCy()"
  (click)="onClose()">
  <lkt-icon name="close" [size]="13" />
</button>

@if (item().body) {
  <span class="nt-toast__body">{{ item().body }}</span>
}

@if (item().ctaLabel) {
  <span class="nt-toast__actions">
    <button type="button" class="nt-toast__cta" [attr.data-cy]="ctaDataCy()" (click)="onCta()">
      {{ item().ctaLabel }}
    </button>
  </span>
}

<!--
  A barra de vida É o aviso de que o tempo está correndo. Só existe quando há
  relógio: com `animate() === false` não há timer (CA 08), e uma barra parada
  prometeria um fechamento que não vem. `--nt-vida` sai de `lifeBarMs()`, um
  SNAPSHOT tirado quando este `<span>` monta (round 6) — não um valor vivo.
  Religar `animate()` no meio de uma pausa remonta o `<span>` com o restante
  congelado (round 5, aberto 2); um hover comum NÃO muda `animate()`, então
  não muda `--nt-vida` — quem congela o avanço visual nesse caso é o CSS
  (`:hover`/`:focus-within` pausando a MESMA animação), não uma nova duração.
  Trocar a duração de uma animação em andamento recalcularia o progresso como
  tempoLocal/novaDuração, fazendo a barra saltar ou zerar (verificado em
  Chrome real, ver relatório da Task 16).
-->
@if (animate()) {
  <span class="nt-toast__life" [style.--nt-vida.ms]="lifeBarMs()"></span>
}
